import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { SummaryContactModel } from "../models/summary-contact.model";
import { ContactModel } from "../models/contact.model";

import { BaseService } from "../../shared/services/base.service";

import { environment } from "../../../../environments/environment";
import { PaginableResponseModel } from "../../common/models/paginable-response.model";
import { SingleResponseModel } from "../../common/models/single-response.model";

@Injectable()
export class ContactService extends BaseService<SummaryContactModel, ContactModel> {

  private fullUrl = `${environment.apiUrl}/api/v2/contacts`;

  constructor(http: HttpClient) {
    super(http, '/api/v2/contacts');
  }

  /** LISTADO */
  getSummaryList(filter: any): Observable<PaginableResponseModel<SummaryContactModel>> {
    return this.http.post<PaginableResponseModel<SummaryContactModel>>(
      `${this.fullUrl}/list`,
      filter
    );
  }

  /** DETALLE POR UID */
  getByUid(uid: string): Observable<SingleResponseModel<ContactModel>> {
    return this.http.get<SingleResponseModel<ContactModel>>(
      `${this.fullUrl}/${uid}`
    );
  }

  /** EXPORTAR A EXCEL */
  export(): Observable<Blob> {
    return this.http.post(
      `${this.fullUrl}/export`,
      {},
      { responseType: 'blob' }
    );
  }

  /** IMPORTAR CONTACTOS */
  import(formData: FormData): Observable<any> {
    return this.http.post(`${this.fullUrl}/import`, formData);
  }

  /** INFORME 347 */
  generateReport347(year: number): Observable<Blob> {
    return this.http.post(
      `${this.fullUrl}/report347/${year}`,
      {},
      { responseType: 'blob' }
    );
  }

  /** OBTENER FACTURAS DE UN CLIENTE */
  getClientInvoices(contactUid: string): Observable<any> {
    return this.http.get(`${this.fullUrl}/${contactUid}/invoices`);
  }

  /** OBTENER GASTOS DE UN PROVEEDOR */
  getProviderExpenses(contactUid: string): Observable<any> {
    return this.http.get(`${this.fullUrl}/${contactUid}/expenses`);
  }
}
